module.exports = __webpack_public_path__ + "static/media/DVClibrary.4e417428.jpg";